<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
            <span class="px-3">{{ $t('View Expense information') }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea">
        <invoice-header class="only-for-print" />

        <v-layout column>
          <v-layout row wrap class="invoice-content">
            <v-flex xs12 sm12 :class="{ 'px-4': $vuetify.breakpoint.smAndUp }">
              <v-layout row wrap>
                <v-flex xs12 style="text-align: center" class="only-for-print" pb-3>
                  <strong>{{ $t('Expenses') }}</strong>
                </v-flex>

                <v-flex xs4 class="pb-3">
                  <div class="caption no-select">{{ $t('Expense Type') }}</div>
                  <strong>{{ expenseInfo.expense_name || '-' }}</strong>
                </v-flex>

                <v-flex xs4 pb-3 :class="{ xs8: expenseInfo.attachment === null }">
                  <div class="caption no-select">{{ $t('Outlet') }}</div>
                  <strong>{{ expenseInfo.outlet_name || '-' }}</strong>
                </v-flex>

                <v-flex xs4 v-if="expenseInfo.attachment !== null" class="not-printable">
                  <v-chip dark color="primary">
                    <v-avatar>
                      <v-icon>insert_drive_file</v-icon>
                    </v-avatar>
                    <a
                      :href="`${baseUrls.images}/${expenseInfo.attachment}`"
                      target="_blank"
                      style="color: white; text-decoration: none"
                    >
                      {{ $t('Click to View Attachment') }}
                    </a>
                  </v-chip>
                </v-flex>

                <v-flex xs4 pb-3>
                  <div class="caption no-select">{{ $t('Amount') }} ({{ systemCurrency }})</div>
                  <strong v-if="expenseInfo.amount">
                    {{ expenseInfo.amount | currency }}
                  </strong>
                  <strong v-else>-</strong>
                </v-flex>

                <!--                <v-flex xs4 class="pb-3">-->
                <!--                  <div class="caption no-select">{{ $t('Payment Type') }}</div>-->
                <!--                  <strong> {{ expenseInfo.payment_type }} </strong>-->
                <!--                </v-flex>-->

                <v-flex xs4 class="pb-3">
                  <div class="caption no-select">{{ $t('Payment Date') }}</div>
                  <strong v-if="expenseInfo.payment_date">
                    {{ expenseInfo.payment_date }}
                  </strong>
                  <strong v-else>-</strong>
                </v-flex>

                <v-flex xs4 class="pb-3">
                  <div class="caption no-select">{{ $t('Supplier') }}</div>
                  <strong>{{ expenseInfo.vender_name || '-' }}</strong>
                </v-flex>

                <v-flex xs4 class="pb-3">
                  <div class="caption no-select">
                    {{ $t('Payment Recipient') }}
                  </div>
                  <strong>{{ expenseInfo.payment_recipient || '-' }}</strong>
                </v-flex>

                <v-flex xs4 class="pb-3">
                  <div class="caption no-select">
                    {{ $t('Voucher Number') }}
                  </div>
                  <strong>{{ expenseInfo.voucher_number || '-' }}</strong>
                </v-flex>

                <v-flex xs12 class="pb-3">
                  <div class="caption no-select">{{ $t('Note') }}</div>
                  <strong v-html="lnToBr(expenseInfo.note) || '-'" />
                </v-flex>

                <v-layout row wrap justify-center mt-4 v-if="paymentNumbers > 0">
                  <table>
                    <tr>
                      <th class="section-title-content">
                        {{ $t('Payment Details') }}
                      </th>
                    </tr>
                  </table>

                  <v-flex xs10>
                    <v-divider />
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="invoice-content" mt-4 v-if="paymentNumbers > 0">
                  <v-flex xs12 sm12>
                    <v-layout row wrap>
                      <table class="printed-table" cellspacing="0">
                        <thead>
                          <tr>
                            <th xs1 class="pa-2 view-table-header">#</th>
                            <th class="view-table-header" xs3 pa-2>
                              {{ $t('Recipient Name') }}
                            </th>
                            <th class="view-table-header" xs3 pa-2>
                              {{ $t('Date') }}
                            </th>
                            <th class="view-table-header" xs2 pa-2>
                              {{ `${$t('Amount')} (${systemCurrency})` }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in paymentNumbers" :key="index">
                            <td class="view-table-row">
                              <p class="view-table-content">{{ index + 1 }}</p>
                            </td>
                            <td class="view-table-row">
                              <p class="view-table-content">
                                {{ paymentDetail.recipient_name[index] }}
                              </p>
                            </td>
                            <td class="view-table-row">
                              <p class="view-table-content">
                                {{ paymentDetail.date[index] }}
                              </p>
                            </td>
                            <td class="view-table-row">
                              <p class="view-table-content">
                                {{ paymentDetail.amount[index] | currency }}
                              </p>
                            </td>
                          </tr>
                          <tr class="last-table-row-for-currency">
                            <td class="view-table-row" colspan="3">
                              <p class="view-table-content">
                                {{ `${$t('Total Paid')}` }}
                              </p>
                            </td>
                            <td class="view-table-row">
                              <p class="view-table-content">
                                {{ paymentDetail.total_paid | currency }}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr class="only-for-print">
                            <td>
                              <div class="footer-space">&nbsp;</div>
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <invoice-footer
                  :showSignatureSection="false"
                  :accountantName="''"
                  :payerRecipientName="''"
                  :payerOrRecipient="''"
                  class="only-for-print"
                />
              </v-layout>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">
            {{ $t('Close') }}
          </v-btn>
          <v-btn color="primary" @click="printMe()">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
            {{ $t('Print') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import ignored from 'print-this'

export default {
  name: 'view-component',

  components: {
    invoiceHeader: () => import('@/views/_partials/invoiceHeader.vue'),
    invoiceFooter: () => import('@/views/_partials/invoiceFooter.vue')
  },

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      hasPaymentDetail: false,
      paymentNumbers: 0,
      paymentDetail: {
        total_paid: 0,
        recipient_name: [],
        date: [],
        amount: []
      }
    }
  },

  watch: {
    viewDialog: {
      immediate: false,
      handler() {
        if (this.viewDialog) {
          this.hasPaymentDetail = this.expenseInfo.payment_detail !== null
          if (this.hasPaymentDetail) {
            this.paymentNumbers = this.expenseInfo.payment_detail.length
            this.paymentDetail.total_paid = this.expenseInfo.paid
            this.expenseInfo.payment_detail.forEach(c => {
              this.paymentDetail.recipient_name.push(c.recipient_name)
              this.paymentDetail.date.push(c.payment_date)
              this.paymentDetail.amount.push(c.amount)
            })
          }
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      expenseInfo: 'expenses/getExpenseInfo'
    })
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    lnToBr(str) {
      return helpers.newLineToBreakLine(str)
    },

    printMe() {
      helpers.doPrinting()
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
</style>
